import { atom } from 'jotai/vanilla';

/**
 * Session state interface (runtime only, not persisted)
 */
export interface Session {
  currentScore: number;
  currentLevel: number;
  isPaused: boolean;
  isGameActive: boolean;
  startTime: number | null;
  elapsedTime: number;
}

/**
 * Session atom - runtime state that resets on page reload
 * No persistence - fresh state each session
 */
export const sessionAtom = atom<Session>({
  currentScore: 0,
  currentLevel: 1,
  isPaused: false,
  isGameActive: false,
  startTime: null,
  elapsedTime: 0,
});

/**
 * Derived atom for checking if game is running
 */
export const isGameRunningAtom = atom((get) => {
  const session = get(sessionAtom);
  return session.isGameActive && !session.isPaused;
});
